export default "__VITE_ASSET__BlexEczb__"